<template>
  <div class="form-row">
    <form class="col-sm-10 p-4">
      <div class="form-group col-sm-12 mb-sm-0 h6">
        <label class="font-weight-bold">Candidate Name:</label>
        <label>{{ fullName(candidate) }}</label>
      </div>

      <div class="form-group col-sm-12 mb-sm-0 h6">
        <label class="font-weight-bold">Date of Birth:</label>
        <label>{{ candidate.date_of_birth }}</label>
      </div>

      <div class="form-group col-sm-12 mb-sm-0 h6" v-if="applicantSearch.currentAddress ">
        <label class="font-weight-bold">Address:</label>
        <label>{{ applicantSearch.currentAddress.address  }}</label>
      </div>

      <div class="form-group col-sm-12 ml-sm-4 mt-sm-2">
        <p class="fontStyle">Using candidate SIA license number or other required information search SIA holders
          register
          and verify license validity</p>
      </div>
      <hr>
      <div class="row mt-sm-4">
        <div class="form-group col-sm-4 mt-sm-3">
          <el-button class="btn btn-primary el-button--default col-sm-12"
                     @click.prevent="openLink()">
            Check Here
          </el-button>
        </div>
        <div class="form-group col-sm-6">
          <label>CHECKED</label>
          <app-input type="radio"
                     :list="yesOrNoList"
                     v-model="creditsCheck.result_status"
          />
        </div>
      </div>
      <div class="row mt-sm-2">
        <document-table :documents="filesForDocumentTable"
                        @onDelete="onTableDelete"
        />
      </div>
      <div class="row">
        <upload-btn :fileObj="creditsCheck"
                    :renderType="type.Search"
                    :emailAddress="candidate.email"
                    :searchDocument="documentObj"
                    :metaData="{
                      ...creditsCheck,
                      statusable_type: statusAble.statusable_type,
                      id: statusAble.statusable_id
                    }"
                    :filesForDocumentTable="filesForDocumentTable"
                    :error="error"/>
        <div class="form-group col-sm-12">
          <p class="col-sm-6 fontStyle errorStyle" v-if="error.isError">
            {{ error.errorMessage }}
          </p>
        </div>
      </div>
      <div class="row mt-sm-2">
        <div class="form-group col-sm-12">
          <label>Results Matched:</label>
          <app-input type="radio"
                     :list="yesOrNoList"
                     v-model="creditsCheck.result_matched"/>
        </div>
        <div class="form-group col-sm-12">

          <label for="Date">Select Date</label>
          <app-input
              class="col-sm-6"
              type="date"
              v-model="creditsCheck.statusDate"
              :value="new Date()"

          />
        </div>
      </div>
      <div class="row mt-sm-2">
        <div class="form-group col-sm-4 mt-sm-3">
          <el-button class="btn btn-primary el-button--default col-sm-12"
                     @click="submitBtn">
            Submit
          </el-button>
        </div>
      </div>

    </form>
    <form class="col-sm-2">
      <drawer-component title="Comments" size="40%">
        <general-comments
            :comments="comments"
            :applicantId="candidate.id"
            :statusable_type="statusAble.statusable_type"
            :statusable_id="statusAble.statusable_id"/>
      </drawer-component>
    </form>
  </div>
</template>

<script>
import {_yesOrNoList, creditsURL} from '@Views/Screening/utility/constant';
import {fullName, pushFileInDocumentTable, saveScreeningSearch} from "@Views/Screening/utility/common";
import {searchType} from "@Views/Screening/utility/enums";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {uploadBtnRenderType} from '@Views/Screening/utility/enums';
import moment from "moment";

export default {
  name: "CreditsCheck",
  mixins: [FormMixin],
  data() {
    return {
      applicantSearch: this.$attrs['props'].applicantSearch,
      candidate: this.$attrs['props'].candidate,
      currentAddress: this.$attrs['props'].currentAddress??{},
      yesOrNoList: _yesOrNoList,
      creditsCheck: {
        search_type: searchType.Credits,
        files: []
      },
      comments: [],
      statusAble: {},
      filesForDocumentTable: [],
      documentObj: {},
      error: {
        isError: false,
        errorMessage: ''
      },
      type: uploadBtnRenderType
    }
  },
  created() {
    this.$hub.$on('pass-steps-in-search-case', (data) => {
      if (data) {
        this.applicantSearch[searchType.Credits][0].screening_status.push(data);
      }
    });
  },
  mounted() {
    this.setPropsIntoObject();
  },

  methods: {
    fullName,
    pushFileInDocumentTable,
    saveScreeningSearch,
    openLink() {
      window.open(creditsURL, '_blank');
    },
    submitBtn() {
      this.saveScreeningSearch(this.candidate.id, this.creditsCheck);
    },
    setPropsIntoObject() {
      const credits = this.applicantSearch[searchType.Credits][0];
      this.$set(this.creditsCheck, 'result_matched', credits.result_matched === 0 ? 'no' : 'yes');
      this.$set(this.creditsCheck, 'result_status', credits.result_status === 0 ? 'no' : 'yes');
      this.$set(this.creditsCheck, 'statusDate', credits.updated_at);
      this.$set(this.statusAble, 'statusable_type', credits.statusable_type);
      this.$set(this.statusAble, 'statusable_id', credits.id);
      if (credits.screening_status.length > 0) {
        this.comments.push(...credits.screening_status);
      }
      if (credits.applicant_files.length > 0) {
        let index = 0;
        for (const file of credits.applicant_files) {
          this.$set(this.filesForDocumentTable, index, {
            id: file.id,
            name: file.file_name,
            fileURL: `/${file.file_path}`,
            uploaded_on: file.created_at
          });
          index++;
        }
      }
    },
    onTableDelete(index) {
      this.applicantSearch[searchType.Credits][0].applicant_files.splice(index, 1);
    }
  },
  watch: {
    documentObj: {
      handler: function () {
        if (this.documentObj.file) {
          this.pushFileInDocumentTable(this.documentObj.file);
          const {name, fileURL, ...rest} = this.documentObj.file;
          this.applicantSearch[searchType.Credits][0].applicant_files.push(rest);
          this.submitBtn();
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.fontStyle {
  font-size: 12px;
}

.errorStyle {
  font-weight: bolder;
  color: red;
}
</style>